import { IAuthGetAvailableTournamentsPayload } from 'modules/auth/domain/interfaces/auth-get-available-tournaments-payload';

import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';
import { AuthAvailableTournament } from '../interfaces/auth-available-tournament';
import { AuthRequestAuthCodePayload } from '../interfaces/auth-request-auth-code-payload';
import { AuthSignInPayload } from '../interfaces/auth-sign-in-payload';
import { type AuthenticatedUser, AuthSignInResponse } from '../interfaces/auth-sign-in-response';
import { AuthSignUpPayload } from '../interfaces/auth-sign-up-payload';
import { AuthSignUpResponse } from '../interfaces/auth-sign-up-response';

interface AvailableTournamentDto {
  id: number;
  name: string;
  sport_type: string;
  slug?: string;
  url?: string;
}

class AuthResource extends Resource {
  constructor() {
    super('users', httpResource);
  }

  public async requestAuthCode(data: AuthRequestAuthCodePayload): Promise<AuthenticatedUser> {
    return this.child('get-temp-password').post<AuthenticatedUser>(data);
  }

  public signIn(data: AuthSignInPayload): Promise<AuthSignInResponse> {
    try {
      return this.absolute('login_check').post(data);
    } catch (err) {
      throw new Error('Invalid credentials');
    }
  }

  public async signUp(data: AuthSignUpPayload): Promise<AuthSignUpResponse> {
    const { firstName: name, lastName: surname, middleName, phone } = data;

    return this.child('get-temp-password').post(
      {
        name,
        surname,
        middleName,
        phone,
        roles: ['ROLE_TOURNAMENT_ADMIN'],
      },
      {
        validateStatus: (status) => status < 500,
      },
    );
  }

  public check(): Promise<AuthSignInResponse['user']> {
    return this.child('current').get();
  }

  public async getAvailableTournaments(params?: IAuthGetAvailableTournamentsPayload): Promise<AuthAvailableTournament[]> {
    const { limit = 10, offset = 0, namePart } = params || {};
    const tournaments = await this.absolute('/tournaments').get<AvailableTournamentDto[]>({
      limit,
      offset,
      namePart,
    });

    return tournaments.map((item) => ({
      id: item.id,
      name: item.name,
      sportType: item.sport_type,
    }));
  }
}

const authResource = new AuthResource();
export default authResource;
